import React, { useState } from 'react';
import { useAPI } from 'api';
import { TaskResponse } from 'types';
import { useOrgContext } from 'components/OrgContextProvider';

const WorkspaceTaskTests = () => {
	const api = useAPI();
	const ctx = useOrgContext();

	const monitorTask = (id: string, setProgress: (progress: number) => void, done: (result: unknown) => void) => {
		const timer = setInterval(
			() => {
				api.get<TaskResponse>(`${ctx?.apiBaseWorkspace}/tasks/${id}`)
				.then(json => {
					console.log(`Task ${id} status`, json);
					setProgress(json.progress);
					if (json.status === 'completed') {
						if (done) done(json.result);
						clearInterval(timer);
					} else if (json.status === 'failed') {
						if (done) done(json.lastError);
						clearInterval(timer);
					} else {
						done(json.status);
					}
				});
			},
			1000
		);
	};

	const useTestTask = (apiPath: string, initialValue: number, taskInputWrapFunction: (input: number) => unknown) => {
		const [taskInput, setTaskInput] = useState(initialValue);
		const [taskResult, setTaskResult] = useState<unknown>(null);
		const [taskProgress, setTaskProgress] = useState(0);

		const startTask = () => {
			api.post<{ id: string }>(apiPath, taskInputWrapFunction(taskInput))
			.then(json => monitorTask(json.id, setTaskProgress, setTaskResult));
		};

		const createUI = () => {
			return (
				<p>
					<input type="text" value={taskInput} onChange={e => setTaskInput(Number(e.target.value))} />&nbsp;&nbsp;
					<button onClick={startTask}>Start Task</button>&nbsp;&nbsp;
					<span>Progress: {taskProgress * 100}%</span>&nbsp;&nbsp;
					<span>Result: {String(taskResult)}</span>
				</p>
			);
		};

		return {
			initialValue,
			apiPath,
			startTask,
			createUI,
			taskInputWrapFunction,
			input: taskInput,
			setInput: setTaskInput,
			result: taskResult,
			setResult: setTaskResult,
			progress: taskProgress,
			setProgress: setTaskProgress
		};
	};

	const systemImmTestTask = useTestTask('/api/experimental/testtask/run', 42, (input: number) => ({ x: input, y: 3 }));
	const systemImmTaskExtProc = useTestTask('/api/experimental/testtaskextproc/run', 100, (input: number) => ({ x: input, y: 3 }));
	const systemOnceTestTask = useTestTask('/api/experimental/testtask/schedule', 150, (input: number) => ({ x: input, y: 3 }));

	const orgImmTestTask = useTestTask(`${ctx?.apiBaseWorkspace}/experimental/testtask/run`, 123, (input: number) => ({ x: input, y: 5 }));
	const orgImmTaskExtProc = useTestTask(`${ctx?.apiBaseWorkspace}/experimental/testtaskextproc/run`, 300, (input: number) => ({ x: input, y: 100 }));
	const orgOnceTestTask = useTestTask(`${ctx?.apiBaseWorkspace}/experimental/testtask/schedule`, 500, (input: number) => ({ x: input, y: 123 }));
	const orgRepeatTestTask = useTestTask(`${ctx?.apiBaseWorkspace}/experimental/testtask/repeat`, 1234, (input: number) => ({ x: input, y: 4567 }));

	return (
		<div>
			<h3>Test Tasks</h3>

			<hr />

			<h4>System-wide test tasks</h4>

			<div><h5>Immediate Test Task</h5> {systemImmTestTask.createUI()}</div>
			<div><h5>Immediate Test Task ExtProc</h5> {systemImmTaskExtProc.createUI()}</div>
			<div><h5>Schedule (Once) Test Task</h5> {systemOnceTestTask.createUI()}</div>

			<hr />

			<h4>Workspace-specific test tasks</h4>

			<div><h5>Immediate Test Task</h5> {orgImmTestTask.createUI()}</div>
			<div><h5>Immediate Test Task ExtProc</h5> {orgImmTaskExtProc.createUI()}</div>
			<div><h5>Schedule (Once) Test Task</h5> {orgOnceTestTask.createUI()}</div>
			<div><h5>Schedule (Repeat) Test Task</h5> {orgRepeatTestTask.createUI()}</div>

		</div>
	);
};

export default WorkspaceTaskTests;
